import React from 'react';
import { Box } from '@mui/material';

export default function StudySectionIcon({ children }: { children: React.ReactNode }) {
  return <Box aria-hidden="true" sx={{ width: 34, height: 34, flexShrink: 0, display: 'grid', placeItems: 'center',
    bgcolor: '#f8eeee', color: 'primary.main', borderRadius: '10px', '& svg': { fontSize: 20 } }}>{children}</Box>;
}
